export default function HeroSection() {
  return (
    <section id="heroSection" className="hero--section">
      <div className="hero--section--content--box">
        <div className="hero--section--content">
          <p className="section--title">Hi, I'm Faiso Abdirsak</p>
          <h1 className="hero--section--title">
            <span className="hero--section-title--color">Software</span> <br />
            Engineer
          </h1>
          <p className="hero--section-description">
            My journey into programming started during my high school days when
            I tinkered with basic programming languages. This initial exposure
            quickly blossomed into a full-blown passion, leading me to pursue a
            degree in Information Technology at Jomo Kenyatta University of
            Agriculture and Technology. During my academic years, I eagerly
            absorbed knowledge about algorithms, data structures, and software
            development methodologies
          </p>
        </div>
        <button className="btn btn-primary">
          Get In Touch
        </button>
    
      </div>
      <div className="hero--section--img">
        <img src="./images/giphy.gif" alt="faisoabdirisak" />
      </div>
    </section>
  );
}
